export enum PostTypeEnum {
  Image = 1,
  Video = 2,
  Link = 5,
  Text = 6,
}
